import * as shape from 'd3-shape'

export default function (rays, center, radius, tipRadius) {
  const line = shape.line()
  const points = getPoints(rays * 2, center, radius, tipRadius)

  return `${line(points)}L${points[0]}Z`
}

export function getPoints (count, center, radius, tipRadius) {
  const angle = (Math.PI * 2) / count

  return Array(count).fill().map((_, i) => {
    const r = i % 2 === 1 ? tipRadius : radius
    const theta = i * angle - (Math.PI / 2)

    return [
      center[0] + r * Math.cos(theta),
      center[1] + r * Math.sin(theta),
    ]
  })
}
